import { Module, VuexModule, Mutation, Action, getModule } from 'vuex-module-decorators';
import { INotification } from '@/types';
import { bindFirebaseRef, unbindFirebaseRef } from '@/plugins/bindFirebaseRef';
import { db } from '@/plugins/firebase';

@Module({ namespaced: true, name: 'notifications' })
export default class Notifications extends VuexModule {
	list: INotification[] = [];

	get unchecked() {
		return this.list.filter((n) => n.state === 'unchecked');
	}

	@Action
	updateNotification(id: string, key: string, value: any) {
		return db.collection('notifications').doc(id).update(key, value);
	}

	@Action
	checkAll() {
		this.list.forEach((n) => {
			if (n.state === 'unchecked') db.collection('notifications').doc(n.id).update('state', 'checked');
		});
	}

	@Action
	bind(payload: { uid: string }) {
		const query = db
			.collection('notifications')
			.where('uid', '==', payload.uid)
			.orderBy('timestamp', 'desc')
			.limit(100);
		bindFirebaseRef(this.context, 'list', query);
	}

	@Action
	unbind() {
		return unbindFirebaseRef(this.context, 'list');
	}
}
